import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ObjectID } from 'bson';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TableCellData, TableColumnWidths } from '@site-mate/dashpivot-shared-library';

import { appControlType } from 'app/apps/app-control-type.model';
import { TemplateTableCellComponent } from 'app/form-fields/table/template/table-cell-items/table-cell.component';
import { ToastrService } from 'app/shared/service/toastr.service';

@Component({
  styleUrls: ['list.component.scss'],
  templateUrl: 'list.component.html',
})
export class TemplateTableListCellComponent implements TemplateTableCellComponent, OnInit, OnDestroy {
  static identifierIndex = 0;
  @Input() cellData: TableCellData & { listItems: any };
  @Input() companyId: string;

  uniqueIdentifier: number;
  controlType = appControlType;
  editingListItem;
  itemLabel = '';
  listItems$ = new BehaviorSubject(null);
  readonly tableColumnWidths = TableColumnWidths;

  private unSubscribe = new Subject<void>();

  constructor(private readonly toastrService: ToastrService) {}

  ngOnInit(): void {
    // eslint-disable-next-line no-plusplus
    this.uniqueIdentifier = TemplateTableListCellComponent.identifierIndex++;
    this.cellData.model.listSource =
      this.cellData.model.listSource || this.controlType.columnType.listSource.list;
    this.cellData.listItems.pipe(takeUntil(this.unSubscribe)).subscribe((list) => {
      this.listItems$.next(list);
    });
  }

  onListSourceChange(sourceType) {
    switch (sourceType) {
      case this.controlType.columnType.listSource.list:
        this.cellData.model.manualListItems = undefined;
        break;
      case this.controlType.columnType.listSource.manual:
        this.cellData.model.reference = '';
        this.cellData.model.content = [];
        break;
      default:
        break;
    }
  }

  addListItem(providedInput) {
    const input = providedInput;
    if (input.value) {
      this.cellData.model.manualListItems = this.cellData.model.manualListItems || [];
      this.cellData.model.manualListItems.push({
        id: new ObjectID().toHexString(),
        value: input.value,
        style: this.cellData.model.defaultColor,
      });
    } else {
      this.toastrService.warnByKey('inputTextBeforeAdd');
    }
    input.value = '';
    input.focus();
  }

  removeListItem(id) {
    this.cellData.model.manualListItems = this.cellData.model.manualListItems.filter((i) => i.id !== id);
  }

  onEditListItem(item) {
    this.editingListItem = item;
  }

  ngOnDestroy(): void {
    this.unSubscribe.next();
    this.unSubscribe.complete();
  }
}
